import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface PublicEvent {
  name: string;
  description: string;
  location: string;
  dates: string;
}

export interface FlightStatus {
  hasAirTravel: boolean;
  flightNumber: string;
  status: string;
  details: string;
}

export interface WeatherRisk {
  city: string;
  travelPeriod: string;
  weatherSummary: string;
  riskLevel: 'Low' | 'Medium' | 'High';
  warnings: string[];
  publicEvents: PublicEvent[];
  topRestaurants: string[];
  topPlaces: string[];
  sources: string[];
  flightStatus?: FlightStatus;
}

@Injectable({
  providedIn: 'root'
})
export class WeatherRiskService {
  private http = inject(HttpClient);
  // NOTE: Replace with your actual API endpoint
  private weatherRiskApiUrl = 'https://n8n-hackathon.dev.triparcdev.com/webhook/fms-trip-risk?tripId='; 

  /**
   * Fetches weather risk data for a given trip ID.
   * @param tripId The ID of the trip.
   * @returns An observable of the weather risk data array.
   */
  getWeatherRiskByTripId(tripId: number): Observable<WeatherRisk[]> {
    // This is a placeholder for the actual API call. 
    // It should ideally use a proper endpoint and parameters.
    return this.http.get<WeatherRisk[]>(`${this.weatherRiskApiUrl}${tripId}`);
  }
}